import { makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    alignItems: 'center',
    gap: 5,
    paddingLeft: 12,
    backgroundColor: theme.palette.background.default,
    textAlign: 'left',
    height: '12vh',
    overflowY: 'auto',
    gridTemplateColumns: '1.5fr 1fr 1fr 1.5fr 1fr 1fr 0.6fr 0.8fr 1.3fr 0.9fr'
  },
  tableRowOdd: {
    backgroundColor: theme.palette.grey[200]
  },
  skeleton: {
    marginTop: '14px!important',
    marginBottom: '14px!important',
    width: '80%'
  },
  cursor: {
    cursor: 'pointer'
  },
  textFont: {
    fontSize: lang === 'en' ? '12.5px' : '11px',
    lineBreak: 'anywhere',
    [theme.breakpoints.up(1680)]: {
      fontSize: lang === 'en' ? '13px' : '12px',
      lineBreak: 'anywhere'
    }
  }
}))
export default useStyles
